export class Session {
  private static instance: Session;
  private _token: string | undefined;
  private _isLoggedIn = false;

  /**
   * The Singleton's constructor should always be private to prevent direct
   * construction calls with the `new` operator.
   */
  //private constructor() {}

  /**
   * The static method that controls the access to the singleton instance.
   *
   * This implementation let you subclass the Singleton class while keeping
   * just one instance of each subclass around.
   */
  public static get Instance(): Session {
    if (!this.instance) {
      this.instance = new Session();
    }

    return this.instance;
  }

  private _onSessionTimeout?: (value: boolean) => void = undefined;
  set onSessionTimeout(sessionTimeout: (value: boolean) => void) {
    this._onSessionTimeout = sessionTimeout;
  }

  sessionTimeout(): void {
    if (this._onSessionTimeout !== undefined) {
      this._onSessionTimeout(true);
    }
  }

  public get token(): string | undefined {
    return this._token;
  }

  public set token(token: string | undefined) {
    this._token = token;
  }

  public get isLoggedIn(): boolean {
    return this._isLoggedIn;
  }

  public set isLoggedIn(isLoggedIn: boolean) {
    this._isLoggedIn = isLoggedIn;
  }

  public logOut(): void {
    this._token = undefined;
    this._isLoggedIn = false;
  }
}
